import { ReferralInput } from '@/features/points/components/referral-input/ReferralInput'
import { UsePointsOnboardingDialogResult } from '@/features/points/dialogs/points-onboarding-dialog/logic/usePointsOnboardingDialog'
import { assets } from '@/ui/assets'
import { Button } from '@/ui/atoms/button/Button'
import { cn } from '@/ui/utils/style'

export function PointsOnboardingView(props: UsePointsOnboardingDialogResult) {
  const { referralValue, onReferralChange, onReferralSkip, action, pointsSeason } = props

  return (
    <div className="relative isolate flex flex-col">
      <img
        src={assets.points.onboardingBg}
        className="absolute top-0 left-0 z-[-1] w-full"
        alt="Points Onboarding view background"
      />
      <div
        className={cn('mt-[40%] flex flex-col items-center gap-3 p-8 text-center sm:gap-8', onReferralSkip && 'pb-1')}
      >
        <div className="flex flex-col gap-3">
          <h1 className="typography-heading-4 sm:typography-heading-3 text-primary-inverse">
            Join Season {pointsSeason} of Spark Points
          </h1>
          <span className="typography-body-4 sm:typography-body-3 text-tertiary">
            Complete missions. Earn points. Climb the ranks.
            <br />
            Unlock limited-time rewards before season {pointsSeason} ends. Spark your way to the top.
          </span>
        </div>
        <ReferralInput
          className="pt-3"
          disabled={action.isPending}
          value={referralValue}
          onChange={onReferralChange}
          error={action.error}
        />
        <div className={cn('flex w-full flex-col items-center gap-3 sm:gap-4', !onReferralSkip && 'mb-4')}>
          <ActionButton {...props} />
          {onReferralSkip && (
            <Button
              variant="transparent"
              onClick={onReferralSkip}
              spacing="none"
              className="pb-3 text-brand-primary hover:text-brand-primary hover:brightness-150 active:text-brand-primary active:brightness-200"
            >
              I don't have an invite code
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

function ActionButton({ action, onCloseEvent }: UsePointsOnboardingDialogResult) {
  const { error, isPending, disabled, onAction, text } = action

  // Applying disabled primary button styles manually for onClick to handle displaying skip button
  const disabledStyles = cn(
    'cursor-not-allowed bg-neutral-50 text-neutral-500 after:opacity-0',
    'hover:bg-neutral-50 hover:after:opacity-0',
    'active:bg-neutral-50 active:text-neutral-500 active:after:opacity-0',
  )

  return (
    <Button
      variant="primary"
      size="l"
      className={cn('w-full', disabled && disabledStyles)}
      disabled={!!error}
      loading={isPending}
      onClick={disabled ? onCloseEvent : onAction}
    >
      {text}
    </Button>
  )
}
